import React from 'react';
import Immutable from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewArticleHighlightsProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ViewArticleHighlights: React.FC<ViewArticleHighlightsProps> = ({ entities }) => (
  <Container>
    <div className="ArticleHighlights">
      {
        entities.map((entity) => {
          const id = entity.getIn(['nid', 0, 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const key = `${uuid}:${langcode}`;

          return (
            <Node
              key={key}
              id={id}
              entity={entity}
              viewMode="highlighted"
            />
          );
        })
      }
    </div>
  </Container>
);

export default ViewArticleHighlights;
